import { useEffect, useState, useMemo } from "react";
import { useMarket } from "../../context/MarketDhanContext";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { useMarketToggle } from "../../context/MarketContext";
import { useAuth } from "../../context/AuthNewContext";
import { useWatchlist } from "../../context/WatchlistContext";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { FaSpinner } from "react-icons/fa6";
import useLivePrices from "../../hooks/useLivePrices";
import { useIndexSymbols } from "../../context/IndexSymbolContext";
import { FiRefreshCw } from "react-icons/fi";
import { FaFireAlt } from "react-icons/fa";
import { FiSave } from "react-icons/fi";
import { FiStar } from "react-icons/fi"; // outline
import { FaStar } from "react-icons/fa"; // filled
import { DASHTOOL } from "../../helper/tooltilData";
import { nseIndicesOptions } from "../Helper/Helperdata";

import MarketCard from "../MarketCard/MarketCard";
import MarketMoverSection from "../MarketMoverSection/MarketMoverSection";
import IndexTabs from "../IndexTabs/IndexTabs";
import { useNavigate } from "react-router-dom";
import topGainersImg from "../../assets/top-gainers.png";
import topLosersImg from "../../assets/top-losers.png";
import mostActiveImg from "../../assets/most-active.png";
import { FiMinusCircle } from "react-icons/fi";
import SparkLine from "../Helper/SparkLine";
import "./TestPage.css";
import SmartMoneySection from "../SmartMoneySection/SmartMoneySection";
import SmartMoneyScreener from "../Screeners/SmartMoneyScreener";

// Outside component
const getElapsedFraction = () => {
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
  );
  const mins = (now.getHours() - 9) * 60 + (now.getMinutes() - 15);
  if (mins <= 0) return 0;
  if (mins >= 375) return 1;
  return mins / 375;
};
export default function TestOHLC() {
  const { indexSymbols } = useIndexSymbols();
  const {
    prices: livePrices,
    isLive,
    subscribeSymbols,
    lastTickTime,
  } = useLivePrices();
  const {
    marketData,

    nseData,
  } = useMarket();
  const navigate = useNavigate();
  const { loadNifty50, loadNifty100 } = useSecurityMaster();
  const { setMoreData } = useMoreStockContext();
  // const { token, username } = useNewAuth();
  // console.log("token and username from auth context", token, username);
  const { user } = useAuth();
  console.log("user data", user);
  const userID = user?.userID;
  const { getSecurityIds } = useSecurityMaster();
  const {
    indicesData,
    getNseIndices,
    getNseIndexData,
    nseIndexData,

    getScreenerData,
    screener,
    getLatestNseData,
    latestNseData,
  } = useMarketIndicators();
  const [id, setId] = useState([]);
  const [activeMarketTab, setActiveMarketTab] = useState("gainer");
  const [activeSectionTab, setActiveSectionTab] = useState("movers");
  const {
    watchlist,
    fetchWatchlist,
    addToWatchlist,
    removeFromWatchlist,
    resetWatchlist,

    isInWatchlist,
  } = useWatchlist();
  const {
    loadDashboardIndexMarket,
    // dashboardMarketData,
    resetDashboardMarketData,
    dashboardIndexData,
    dashboardLoading,
    dashboardError,
    dashboardIndexTab,
    getDashboardData,
    dashboardData,
    dashboardDataLoading,
    dashboardDataError,
  } = useMarketSnapshot();
  const [selectedIndex, setSelectedIndex] = useState(
    () => localStorage.getItem("selectedIndex") || "NIFTY 50",
  );
  const [lastUpdated, setLastUpdated] = useState(null);
  const [indexChanging, setIndexChanging] = useState(false);
  const [minuteTick, setMinuteTick] = useState(0);
  const { market } = useMarketToggle();
  console.log("Market selected is", market);
  // console.log("Dashboad indes tabs", dashboardIndexTab);
  const isIndia = market === "india";
  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };
  // useEffect(() => {
  //   if (marketData?.length) {
  //     setLastUpdated(formatTimestamp());
  //   }
  // }, [marketData]);
  useEffect(() => {
    if (screener && Object.keys(screener).length > 0) return;
    // getScreenerData(["day_gainers", "day_losers", "most_actives"]);
    getScreenerData();
  }, []);

  //new
  // ➕ ADD THIS
  useEffect(() => {
    const id = setInterval(() => setMinuteTick((n) => n + 1), 60_000);
    return () => clearInterval(id);
  }, []);
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };

  //working code
  // const handleRefresh = async () => {
  //   getLatestNseData(selectedIndex);
  //   setLastUpdated(formatTimestamp());
  // };
  const handleRefresh = async () => {
    try {
      await loadDashboardIndexMarket({
        indexName: selectedIndex,
      });
    } catch (err) {
      console.error("Refresh failed", err);
    }
  };
  const getTopMovers = (data, type = "gainers", limit = 10) => {
    const sorted = [...data]?.filter(
      (s) => typeof s.percent_change === "number",
    );

    sorted?.sort((a, b) =>
      type === "gainers"
        ? b.percent_change - a.percent_change
        : a.percent_change - b.percent_change,
    );

    return sorted?.slice(0, limit);
  };
  const gainers = getTopMovers(marketData, "gainers", 10);
  const losers = getTopMovers(marketData, "losers", 10);
  console.log("Gainers", gainers);
  console.log("Losers", losers);
  console.log("Nse data", nseData);
  console.log("Nse indices", indicesData);

  //previous working code commented
  // const handleIndexSelect = async (e) => {
  //   const value = e.target.value;
  //   if (!value) return;

  //   try {
  //     setIndexChanging(true);
  //     resetDashboardMarketData();
  //     setSelectedIndex(value);

  //     await loadDashboardIndexMarket({
  //       indexName: value,
  //     });
  //   } catch (err) {
  //     console.error("Index change failed", err);
  //   } finally {
  //     setIndexChanging(false);
  //   }
  // };
  const handleIndexSelect = async (e) => {
    const value = e.target.value;
    if (!value) return;

    try {
      setIndexChanging(true);
      resetDashboardMarketData();
      setSelectedIndex(value);
      // getLatestNseData(value);
      // getNseIndexData(value);

      // Re-subscribe with BOTH equities + index names
      const equitySymbols = indexSymbols?.[value] || [];
      const indexNames = dashboardIndexTab?.map((t) => t.index_name) || [];
      const allSymbols = [...new Set([...equitySymbols, ...indexNames])];
      if (allSymbols.length) subscribeSymbols(allSymbols);

      // await loadDashboardIndexMarket({ indexName: value });
      await getDashboardData({ indexName: value });
    } catch (err) {
      console.error("Index change failed", err);
    } finally {
      setIndexChanging(false);
    }
  };

  // const handleIndexSelect = async (e) => {
  //   const value = e.target.value;
  //   if (!value) return;

  //   setSelectedIndex(value);

  //   // ADD optional chaining here too
  //   const symbols = indexSymbols?.[value] || [];
  //   if (symbols.length) subscribeSymbols(symbols);

  //   resetDashboardMarketData();
  //   loadDashboardIndexMarket({ indexName: value });
  // };
  const dashboardMarketData = dashboardData?.data;
  console.log("Data", marketData);
  console.log("Index data ", nseIndexData);
  // console.log("lastets nse data", latestNseData);
  //original data form api nse previous
  // const indexSymbolData = nseIndexData?.data?.data;
  //new data
  // const indexSymbolData = latestNseData?.data;
  // console.log("index data latest from", indexSymbolData1);
  // console.log("Index symbol data", indexSymbolData);
  // const dataToRender = indexSymbolData?.filter((item) => item?.priority !== 1);
  // const dataForIndex = indexSymbolData?.filter(
  //   (item) => item?.priority !== 0,
  // )?.[0];
  // console.log("data for index", dataForIndex);
  // const stocks = Array.isArray(dataToRender) ? dataToRender : [];
  // const topGainers = [...stocks]
  //   .filter((s) => typeof s.pChange === "number")
  //   .sort((a, b) => b.pChange - a.pChange)
  //   .slice(0, 5);

  // const topLosers = [...stocks]
  //   .filter((s) => typeof s.pChange === "number")
  //   .sort((a, b) => a.pChange - b.pChange)
  //   .slice(0, 5);

  // const stockActive = [...stocks]
  //   .filter((s) => typeof s.totalTradedVolume === "number")
  //   .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
  //   .slice(0, 5);

  useEffect(() => {
    if (selectedIndex) localStorage.setItem("selectedIndex", selectedIndex);
  }, [selectedIndex]);

  //previous working code
  // useEffect(() => {
  //   if (!selectedIndex) {
  //     setSelectedIndex("NIFTY 50");
  //     return;
  //   }

  //   const hasData =
  //     dashboardMarketData && Object.keys(dashboardMarketData).length > 0;
  //   if (!hasData) {
  //     loadDashboardIndexMarket({ indexName: selectedIndex });
  //   }
  // }, []);

  //new code
  // useEffect(() => {
  //   if (!selectedIndex) {
  //     setSelectedIndex("NIFTY 50");
  //     return;
  //   }

  //   // ADD optional chaining — prevents crash when indexSymbols is empty
  //   const symbols = indexSymbols?.[selectedIndex] || [];
  //   if (symbols.length) subscribeSymbols(symbols);

  //   const hasData =
  //     dashboardMarketData && Object.keys(dashboardMarketData).length > 0;
  //   if (!hasData) {
  //     loadDashboardIndexMarket({ indexName: selectedIndex });
  //   }
  // }, [indexSymbols]);

  // In TestOHLC, update the useEffect:
  // useEffect(() => {
  //   if (!selectedIndex) {
  //     setSelectedIndex("NIFTY 50");
  //     return;
  //   }

  //   const equitySymbols = indexSymbols?.[selectedIndex] || [];
  //   const indexNames = dashboardIndexTab?.map((t) => t.index_name) || [];

  //   // Combine both — single subscribe keeps everything alive
  //   const allSymbols = [...new Set([...equitySymbols, ...indexNames])];
  //   if (allSymbols.length) subscribeSymbols(allSymbols);

  //   const hasData =
  //     dashboardMarketData && Object.keys(dashboardMarketData).length > 0;
  //   if (!hasData) {
  //     loadDashboardIndexMarket({ indexName: selectedIndex });
  //     getDashboardData({ indexName: selectedIndex });
  //     // getNseIndexData(selectedIndex);
  //     // getLatestNseData(selectedIndex);
  //   }
  // }, [indexSymbols, dashboardIndexTab]);
  useEffect(() => {
    if (!selectedIndex) {
      setSelectedIndex("NIFTY 50");
      return;
    }

    const equitySymbols = indexSymbols?.[selectedIndex] || [];
    const indexNames = dashboardIndexTab?.map((t) => t.index_name) || [];

    // Explicitly include selectedIndex itself
    const allSymbols = [
      ...new Set([selectedIndex, ...equitySymbols, ...indexNames]),
    ];

    if (allSymbols.length) subscribeSymbols(allSymbols);
    const hasData = dashboardMarketData && dashboardMarketData.length > 0;
    if (!hasData) {
      getDashboardData({ indexName: selectedIndex });
    }
    // ... rest of your logic
  }, [indexSymbols, dashboardIndexTab, selectedIndex]); // ← add selectedIndex
  const testIndices = [
    { key: "NIFTY", label: "NIFTY 50" },
    { key: "BANKNIFTY", label: "NIFTY BANK" },
    { key: "MIDCPNIFTY", label: "NIFTY MIDCAP 100" },
    // { key: "FINNIFTY", label: "NIFTY FIN SERVICE" },
    // { key: "NIFTY100", label: "NIFTY 100" },
    { key: "NIFTYIT", label: "NIFTY IT" },
    { key: "NIFTYNXT50", label: "NIFTY NEXT 50" },
  ];

  // console.log("dataToRender", dataToRender);
  // console.log("dahsboard index data", dashboardIndexData);

  // const indexQuote = dashboardIndexData?.quote?.data;
  const indexQuote = dashboardData?.selectedIndex?.last_price;
  console.log("indexQUote", indexQuote);
  const liveIndex = livePrices[selectedIndex];

  // const indexLastPrice = indexQuote?.last_price;
  const indexLastPrice = liveIndex?.ltp ?? indexQuote;
  // const indexOhlc = indexQuote?.ohlc;
  // console.log("index ohlc", indexOhlc?.close);
  // const prevClose = dashboardIndexData?.hist_data?.hist?.close?.at(-1);
  const prevClose = Number(dashboardData?.selectedIndex?.prev_close);
  // console.log("prevclose", prevClose);

  // const indexLastPrice = Number(liveIndex?.ltp ?? indexQuote?.last_price);

  // const prevClose = Number(dashboardData?.selectedIndex?.prev_close);

  const hasValidPrices =
    Number.isFinite(indexLastPrice) &&
    Number.isFinite(prevClose) &&
    prevClose !== 0;

  // const indexPChange = hasValidPrices
  //   ? Number((((indexLastPrice - prevClose) / prevClose) * 100).toFixed(2))
  //   : 0;

  // const indexPChange = (
  //   ((indexLastPrice - prevClose) / prevClose) *
  //   100
  // ).toFixed(2);

  const indexPChange =
    liveIndex?.percentChange ||
    (Number(prevClose) && indexLastPrice
      ? Number((((indexLastPrice - prevClose) / prevClose) * 100).toFixed(2))
      : 0);
  console.log("indexPerchange", indexPChange);

  // const advances = dataToRender?.filter((item) => item?.pChange > 0)?.length;
  // console.log("ADVANCES", advances);
  // const declines = dataToRender?.filter((item) => item?.pChange < 0)?.length;
  // console.log("Declines", declines);
  // const unChanged = dataToRender?.filter((item) => item?.pChange === 0)?.length;
  // console.log("UnChanged", unChanged);

  // useEffect(() => {
  //   if (!isIndia) {

  //   }
  // }, [isIndia]);
  console.log("Screener data :", screener); //screener

  const normalizeGlobalStock = (stock) => {
    return {
      ...stock,

      symbol: stock?.symbol,

      lastPrice: stock?.regularMarketPrice ?? 0,

      pChange: stock?.regularMarketChangePercent ?? 0,

      totalTradedVolume: stock?.regularMarketVolume ?? 0,

      currency: stock?.financialCurrency || stock?.currency || "USD",

      companyName:
        stock?.shortName ||
        stock?.longName ||
        stock?.displayName ||
        stock?.symbol,

      security_id: null,

      isGlobal: true,
    };
  };
  const globalGainersNormalized = useMemo(() => {
    return (screener?.data?.day_gainers || []).map(normalizeGlobalStock);
  }, [screener?.data?.day_gainers]);

  const globalLosersNormalized = useMemo(() => {
    return (screener?.data?.day_losers || []).map(normalizeGlobalStock);
  }, [screener?.data?.day_losers]);

  const globalActiveNormalized = useMemo(() => {
    return (screener?.data?.most_actives || []).map(normalizeGlobalStock);
  }, [screener?.data?.most_actives]);

  // const nseIndicesOptions = [
  //   "NIFTY 50",
  //   "NIFTY BANK",
  //   "NIFTY IT",
  //   "NIFTY NEXT 50",
  //   "NIFTY MIDCAP 50",
  //   "NIFTY MIDCAP 100",
  // ];

  const handleAdd = async (symbol) => {
    const exists = isInWatchlist(symbol); // ✅ check first

    try {
      if (exists) {
        // 🔥 REMOVE
        await removeFromWatchlist({ userID, symbol });
      } else {
        // 🔥 ADD (your existing logic untouched)
        const res = await getSecurityIds([symbol]);
        const securityId = res?.[0]?.security_id;

        await addToWatchlist({
          userID,
          symbol,
          securityId,
        });
      }
    } catch (err) {
      console.error("Toggle failed:", err);
    }
  };

  //watchlist
  useEffect(() => {
    if (!userID) return;

    fetchWatchlist(userID);
  }, [userID]);
  const toggleWatchlist = async (symbol) => {
    const exists = isInWatchlist(symbol); // ✅ reuse

    try {
      if (exists) {
        await removeFromWatchlist({ userID, symbol });
      } else {
        await addToWatchlist({ userID, symbol });
      }
    } catch (err) {
      console.error("Toggle failed:", err);
    }
  };

  const globalAllStocks = useMemo(() => {
    return [
      ...(screener?.data?.day_gainers || []),
      ...(screener?.data?.day_losers || []),
      ...(screener?.data?.most_actives || []),
    ];
  }, [screener]);

  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   if (!latestNseData?.data?.length) return;

  //   loadDashboardIndexMarket({
  //     indexName: selectedIndex,

  //   });
  // }, [latestNseData]);
  console.log("Dashboard data ", dashboardMarketData);
  const currentMarketRows = Object.values(dashboardMarketData || {});
  // const newCurrentRows = Object.values(dashboardIndexData?.data || {});
  // console.log("New current rows for index", newCurrentRows);
  console.log("dashboad new data from db", dashboardData);
  //previous working code
  // const snapshotStocks = currentMarketRows
  //   .map((item) => {
  //     const quote = item?.quote?.data;

  //     const lastPrice = quote?.last_price;
  //     const prevClose = quote?.ohlc?.close;

  //     const pChange =
  //       prevClose && lastPrice
  //         ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
  //         : 0;

  //     return {
  //       symbol: item?.symbol,
  //       security_id: item?.security_id,

  //       lastPrice,
  //       pChange,

  //       totalTradedVolume: quote?.volume || 0,
  //       dayLow: quote?.ohlc?.low,
  //       dayHigh: quote?.ohlc?.high,
  //       open: quote?.ohlc?.open,
  //       previousClose: prevClose,
  //       yearHigh: quote?.["52_week_high"],

  //       snapshot: item,
  //     };
  //   })
  //   .filter((item) => item?.symbol && item?.lastPrice);
  // const snapshotStocks = currentMarketRows
  //   .map((item) => {
  //     const quote = item?.quote?.data;
  //     const live = livePrices[item?.symbol];

  //     const lastPrice = live?.ltp || quote?.last_price;
  //     const prevClose = quote?.ohlc?.close;

  //     const pChange =
  //       live?.percentChange ??
  //       (prevClose && lastPrice
  //         ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
  //         : 0);

  //     return {
  //       symbol: item?.symbol,
  //       security_id: item?.security_id,
  //       lastPrice,
  //       pChange,
  //       totalTradedVolume: live?.volume || quote?.volume || 0,
  //       dayLow: live?.low || quote?.ohlc?.low,
  //       dayHigh: live?.high || quote?.ohlc?.high,
  //       open: live?.open || quote?.ohlc?.open,
  //       previousClose: prevClose,
  //       yearHigh: quote?.["52_week_high"],
  //       lastTradeTime: live?.lastTradeTime || item?.quote_updated_at,
  //       snapshot: item,
  //     };
  //   })
  //   .filter((item) => item?.symbol && item?.lastPrice);
  // Wrap snapshotStocks in useMemo:

  // const newSnapshotStocks = useMemo(() => {
  //   return newCurrentRows
  //     .map((item) => {
  //       const live = livePrices?.[item?.symbol];

  //       const lastPrice = live?.ltp ?? item?.lastPrice ?? null;

  //       const previousClose = item?.previousClose ?? null;

  //       const pChange =
  //         live?.percentChange ??
  //         item?.pChange ??
  //         (previousClose && lastPrice
  //           ? Number(
  //               (((lastPrice - previousClose) / previousClose) * 100).toFixed(
  //                 2,
  //               ),
  //             )
  //           : 0);

  //       return {
  //         symbol: item?.symbol,

  //         security_id: item?.security_id ?? item?.securityId ?? null,

  //         lastPrice,
  //         pChange,

  //         totalTradedVolume: live?.volume ?? item?.totalTradedVolume ?? 0,

  //         dayLow: live?.low ?? item?.dayLow ?? null,

  //         dayHigh: live?.high ?? item?.dayHigh ?? null,

  //         open: live?.open ?? item?.open ?? null,

  //         previousClose,

  //         yearHigh: item?.yearHigh ?? null,

  //         yearLow: item?.yearLow ?? null,

  //         companyName: item?.companyName ?? item?.symbol,

  //         lastTradeTime: live?.lastTradeTime ?? item?.lastUpdateTime ?? null,

  //         totalTradedValue: item?.totalTradedValue ?? 0,

  //         change: item?.change ?? 0,

  //         priority: item?.priority,

  //         series: item?.series,

  //         snapshot: item,
  //       };
  //     })
  //     .filter(
  //       (item) =>
  //         item?.symbol && item?.priority !== 1 && item?.lastPrice != null,
  //     );
  // }, [newCurrentRows, livePrices]);

  //previously working code without prevVolume
  // const snapshotStocks = useMemo(() => {
  //   return currentMarketRows
  //     .map((item) => {
  //       const quote = item?.quote?.data;
  //       const live = livePrices[item?.symbol];

  //       const lastPrice = live?.ltp || quote?.last_price;
  //       const prevClose = quote?.ohlc?.close;

  //       const pChange =
  //         live?.percentChange ??
  //         (prevClose && lastPrice
  //           ? Number((((lastPrice - prevClose) / prevClose) * 100).toFixed(2))
  //           : 0);

  //       return {
  //         symbol: item?.symbol,
  //         security_id: item?.security_id,
  //         lastPrice,
  //         pChange,
  //         totalTradedVolume: live?.volume || quote?.volume || 0,
  //         dayLow: live?.low || quote?.ohlc?.low,
  //         dayHigh: live?.high || quote?.ohlc?.high,
  //         open: live?.open || quote?.ohlc?.open,
  //         previousClose: prevClose,
  //         yearHigh: quote?.["52_week_high"],
  //         lastTradeTime: live?.lastTradeTime || item?.quote_updated_at,
  //         snapshot: item,
  //       };
  //     })
  //     .filter((item) => item?.symbol && item?.lastPrice);
  // }, [currentMarketRows, livePrices]);

  //new code with prevVOlume change
  const parseVolume = (value) => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const parsed = Number(String(value).replace(/,/g, "").trim());

    return Number.isFinite(parsed) ? parsed : null;
  };

  // const snapshotStocks = useMemo(() => {
  //   const fraction = getElapsedFraction(); // ➕ ADD THIS LINE

  //   return currentMarketRows
  //     .map((item) => {
  //       const quote = item?.quote?.data;
  //       const live = livePrices?.[item?.symbol];

  //       const lastPrice = live?.ltp || quote?.last_price;
  //       const prevClose = item?.prev_close || quote?.ohlc?.close;

  //       const pChange =
  //         live?.percentChange ||
  //         (prevClose && lastPrice
  //           ? Number(
  //               (
  //                 ((Number(lastPrice) - Number(prevClose)) /
  //                   Number(prevClose)) *
  //                 100
  //               ).toFixed(2),
  //             )
  //           : 0);

  //       const totalTradedVolume =
  //         parseVolume(live?.volume) ?? parseVolume(quote?.volume) ?? 0;

  //       const prevVolume = parseVolume(item?.prev_volume);

  //       // ➕ REPLACE old volumeChange with this
  //       const expectedVolume =
  //         prevVolume && fraction > 0 ? prevVolume * fraction : null;

  //       const volumeChange =
  //         expectedVolume && expectedVolume > 0
  //           ? Number(
  //               (
  //                 ((totalTradedVolume - expectedVolume) / expectedVolume) *
  //                 100
  //               ).toFixed(2),
  //             )
  //           : null;

  //       const volumeChangeColor =
  //         volumeChange === null
  //           ? "#6b7280"
  //           : volumeChange > 0
  //             ? "#16a34a"
  //             : volumeChange < 0
  //               ? "#dc2626"
  //               : "#6b7280";

  //       return {
  //         symbol: item?.symbol,
  //         security_id: item?.security_id,
  //         lastPrice,
  //         pChange,

  //         totalTradedVolume,
  //         prev_volume: prevVolume,
  //         volumeChange,
  //         volumeChangeColor,

  //         dayLow: live?.low ?? quote?.ohlc?.low,
  //         dayHigh: live?.high ?? quote?.ohlc?.high,
  //         open: live?.open ?? quote?.ohlc?.open,
  //         previousClose: prevClose,
  //         yearHigh: quote?.["52_week_high"],
  //         lastTradeTime: live?.lastTradeTime ?? item?.quote_updated_at,
  //         snapshot: item,
  //       };
  //     })
  //     .filter((item) => item?.symbol && item?.lastPrice);
  // }, [currentMarketRows, livePrices, minuteTick]); // ➕ ADD minuteTick here

  // const snapshotStocks = useMemo(() => {
  //   return currentMarketRows
  //     .map((item) => {
  //       const quote = item?.quote?.data;
  //       const live = livePrices?.[item?.symbol];

  //       const lastPrice = live?.ltp || quote?.last_price;
  //       const prevClose = quote?.ohlc?.close;

  //       // const pChange =
  //       //   live?.percentChange ??
  //       //   (prevClose && lastPrice
  //       //     ? Number(
  //       //         (
  //       //           ((Number(lastPrice) - Number(prevClose)) /
  //       //             Number(prevClose)) *
  //       //           100
  //       //         ).toFixed(2),
  //       //       )
  //       //     : 0);
  //       const pChange =
  //         live?.percentChange ||
  //         (prevClose && lastPrice
  //           ? Number(
  //               (
  //                 ((Number(lastPrice) - Number(prevClose)) /
  //                   Number(prevClose)) *
  //                 100
  //               ).toFixed(2),
  //             )
  //           : 0);

  //       /*
  //        * Current volume:
  //        * - live WebSocket volume during market hours
  //        * - stored quote volume when live is unavailable
  //        */
  //       const totalTradedVolume =
  //         parseVolume(live?.volume) ?? parseVolume(quote?.volume) ?? 0;

  //       // prev_volume is directly on market_snapshots row
  //       const prevVolume = parseVolume(item?.prev_volume);

  //       const volumeChange =
  //         prevVolume !== null && prevVolume > 0
  //           ? Number(
  //               (((totalTradedVolume - prevVolume) / prevVolume) * 100).toFixed(
  //                 2,
  //               ),
  //             )
  //           : null;

  //       const volumeChangeColor =
  //         volumeChange === null
  //           ? "#6b7280"
  //           : volumeChange > 0
  //             ? "#16a34a"
  //             : volumeChange < 0
  //               ? "#dc2626"
  //               : "#6b7280";

  //       return {
  //         symbol: item?.symbol,
  //         security_id: item?.security_id,
  //         lastPrice,
  //         pChange,

  //         totalTradedVolume,
  //         prev_volume: prevVolume,
  //         volumeChange,
  //         volumeChangeColor,

  //         dayLow: live?.low ?? quote?.ohlc?.low,
  //         dayHigh: live?.high ?? quote?.ohlc?.high,
  //         open: live?.open ?? quote?.ohlc?.open,
  //         previousClose: prevClose,
  //         yearHigh: quote?.["52_week_high"],
  //         lastTradeTime: live?.lastTradeTime ?? item?.quote_updated_at,
  //         snapshot: item,
  //       };
  //     })
  //     .filter((item) => item?.symbol && item?.lastPrice);
  // }, [currentMarketRows, livePrices]);

  // Wrap sorting in useMemo:
  const snapshotStocks = useMemo(() => {
    const fraction = getElapsedFraction();

    return currentMarketRows
      .map((item) => {
        const quote = item?.quote?.data;
        const live = livePrices?.[item?.symbol];

        const lastPrice = live?.ltp || quote?.last_price;
        const prevClose = item?.prev_close;

        const pChange =
          live?.percentChange ||
          (prevClose && lastPrice
            ? Number(
                (
                  ((Number(lastPrice) - Number(prevClose)) /
                    Number(prevClose)) *
                  100
                ).toFixed(2),
              )
            : 0);

        // ═══ Use quote volume (cumulative), NOT live?.volume (might be per-tick) ═══
        const totalTradedVolume = parseVolume(quote?.volume) ?? 0;

        const prevVolume = parseVolume(item?.prev_volume);

        const expectedVolume =
          prevVolume && fraction > 0 ? prevVolume * fraction : null;

        const volumeBuildPercent =
          expectedVolume && expectedVolume > 0 && totalTradedVolume > 0
            ? Number(
                (
                  ((totalTradedVolume - expectedVolume) / expectedVolume) *
                  100
                ).toFixed(2),
              )
            : null;

        const volumeBuildColor =
          volumeBuildPercent === null
            ? "#6b7280"
            : volumeBuildPercent > 0
              ? "#16a34a"
              : volumeBuildPercent < 0
                ? "#dc2626"
                : "#6b7280";

        return {
          symbol: item?.symbol,
          security_id: item?.security_id,
          lastPrice,
          pChange,
          totalTradedVolume,
          volumeBuildPercent,
          volumeBuildColor,
          dayLow: live?.low ?? quote?.ohlc?.low,
          dayHigh: live?.high ?? quote?.ohlc?.high,
          open: live?.open ?? quote?.ohlc?.open,
          previousClose: prevClose,
          yearHigh: quote?.["52_week_high"],
          lastTradeTime: live?.lastTradeTime ?? item?.quote_updated_at,
          snapshot: item,
        };
      })
      .filter((item) => item?.symbol && item?.lastPrice);
  }, [currentMarketRows, livePrices, minuteTick]);
  // const stocksDb = snapshotStocks.length
  //   ? snapshotStocks
  //   : Array.isArray(dataToRender)
  //     ? dataToRender
  //     : [];
  const stocksDb = snapshotStocks.length > 0 ? snapshotStocks : [];

  // const stocksDb1 = newSnapshotStocks.length
  //   ? newSnapshotStocks
  //   : Array.isArray(dataToRender)
  //     ? dataToRender
  //     : [];
  // console.log("Stockdb1", stocksDb1);
  const topGainersDb = useMemo(() => {
    return [...stocksDb]
      .filter((s) => typeof s.pChange === "number")
      .sort((a, b) => b.pChange - a.pChange)
      .slice(0, 5);
  }, [stocksDb]);

  const topLosersDb = useMemo(() => {
    return [...stocksDb]
      .filter((s) => typeof s.pChange === "number")
      .sort((a, b) => a.pChange - b.pChange)
      .slice(0, 5);
  }, [stocksDb]);

  const stockActiveDb = useMemo(() => {
    return [...stocksDb]
      .filter((s) => typeof s.totalTradedVolume === "number")
      .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
      .slice(0, 5);
  }, [stocksDb]);

  //new
  // const topGainersDb1 = useMemo(() => {
  //   return [...stocksDb1]
  //     .filter((s) => typeof s.pChange === "number")
  //     .sort((a, b) => b.pChange - a.pChange)
  //     .slice(0, 5);
  // }, [stocksDb1]);

  // const topLosersDb1 = useMemo(() => {
  //   return [...stocksDb1]
  //     .filter((s) => typeof s.pChange === "number")
  //     .sort((a, b) => a.pChange - b.pChange)
  //     .slice(0, 5);
  // }, [stocksDb1]);

  // const stockActiveDb1 = useMemo(() => {
  //   return [...stocksDb1]
  //     .filter((s) => typeof s.totalTradedVolume === "number")
  //     .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
  //     .slice(0, 5);
  // }, [stocksDb1]);

  // console.log("Gainers", topGainersDb1);
  // console.log("Gainer from db", topLosersDb1);
  // console.log("Gainer from db", stockActiveDb1);

  // const topGainersDb = [...stocksDb]
  //   .filter((s) => typeof s.pChange === "number")
  //   .sort((a, b) => b.pChange - a.pChange)
  //   .slice(0, 5);

  // const topLosersDb = [...stocksDb]
  //   .filter((s) => typeof s.totalTradedVolume === "number")
  //   .sort((a, b) => a.pChange - b.pChange)
  //   .slice(0, 5);

  // const stockActiveDb = [...stocksDb]
  //   .filter((s) => typeof s.totalTradedVolume === "number")
  //   .sort((a, b) => b.totalTradedVolume - a.totalTradedVolume)
  //   .slice(0, 5);

  console.log("Gainer from db", topGainersDb);
  console.log("Gainer from db", topLosersDb);
  console.log("Gainer from db", stockActiveDb);

  const { advances, declines, unChanged } = useMemo(() => {
    let adv = 0;
    let dec = 0;
    let unc = 0;

    stocksDb?.forEach((item) => {
      if (item?.pChange > 0) adv++;
      else if (item?.pChange < 0) dec++;
      else unc++;
    });

    return {
      advances: adv,
      declines: dec,
      unChanged: unc,
    };
  }, [stocksDb]);

  // const gainersToRender = isIndia ? topGainersDb : global_gainers;
  // const losersToRender = isIndia ? topLosersDb : global_losers;
  // const activesToRender = isIndia ? stockActiveDb : global_active;
  const gainersToRender = isIndia ? topGainersDb : globalGainersNormalized;

  const losersToRender = isIndia ? topLosersDb : globalLosersNormalized;

  const activesToRender = isIndia ? stockActiveDb : globalActiveNormalized;
  const { globalAdvances, globalDeclines, globalUnchanged } = useMemo(() => {
    let adv = 0;
    let dec = 0;
    let unc = 0;

    globalAllStocks.forEach((stock) => {
      const change = stock?.regularMarketChangePercent;

      if (change > 0) adv++;
      else if (change < 0) dec++;
      else unc++;
    });

    return {
      globalAdvances: adv,
      globalDeclines: dec,
      globalUnchanged: unc,
    };
  }, [globalAllStocks]);

  console.log(
    "Advances,decline",
    globalAdvances,
    globalDeclines,
    globalUnchanged,
  );
  //final advances
  const finalAdvances = isIndia ? advances : globalAdvances;
  const finalDeclines = isIndia ? declines : globalDeclines;
  const finalUnchanged = isIndia ? unChanged : globalUnchanged;
  const currentMarketRows1 = Object.values(dashboardMarketData || {});

  const latestQuoteTimestamp = currentMarketRows1.reduce((latest, item) => {
    const current = new Date(item?.quote_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  console.log("New timstamp quotw", latestQuoteTimestamp);
  const formatTimestamp1 = (dateValue) => {
    if (!dateValue) return "";

    const now = new Date(dateValue);

    if (isNaN(now)) return "";

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  //tootltip
  const InfoTooltip = ({ text }) => {
    if (!Array.isArray(text)) return null;

    return (
      <span className="table-tooltip-wrapper">
        <span style={{ color: "black" }}> ⓘ</span>
        <div className="table-tooltip-content">
          {text.map((item) => (
            <div key={item.id} className="tooltip-line">
              {item.text}
            </div>
          ))}
        </div>
      </span>
    );
  };

  // const formattedQuoteTime = formatTimestamp1(latestQuoteTimestamp);
  const dbQuoteTimestamp = currentMarketRows1.reduce((latest, item) => {
    const current = new Date(item?.quote_updated_at);
    return current > latest ? current : latest;
  }, new Date(0));

  // Live timestamp takes priority, falls back to DB
  console.log("Dash time", lastTickTime);
  const displayTimestamp = lastTickTime || dbQuoteTimestamp;
  const formattedQuoteTime = formatTimestamp1(displayTimestamp);
  console.log("Dashboard data", dashboardMarketData);
  // const hasData =
  //   dashboardMarketData && Object.keys(dashboardMarketData).length > 0;
  const hasData = dashboardMarketData?.length > 0;
  // const isFirstLoad = dashboardLoading && !hasData;
  const isFirstLoad = dashboardDataLoading || indexChanging;
  console.log("Is Array", Array.isArray(dashboardIndexTab));
  console.log("Dashboard Tabs", dashboardIndexTab);
  console.log("Index last Price", indexLastPrice);

  // const indexQuote = dashboardIndexData?.quote?.data;

  // const indexLastPrice = liveIndex?.ltp || indexQuote?.last_price;

  // const prevClose = dashboardIndexData?.hist_data?.hist?.close?.at(-1);

  return (
    <div>
      <div className="index-row">
        {isIndia && (
          <>
            <div className="select-option dropdown testpage-inner-dropdown">
              <label className="test-page-label">
                Choose Index
                {/* <InfoTooltip text={DASHTOOL?.indexSelector} /> */}
              </label>

              <div className="select-span-index">
                <select
                  className="test-select"
                  onChange={handleIndexSelect}
                  value={selectedIndex}
                >
                  <option value="">Select</option>
                  {nseIndicesOptions?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                <span
                  className="index-price-data"
                  // style={{
                  //   color:
                  //     dataForIndex?.pChange > 0
                  //       ? "#16a34a"
                  //       : dataForIndex?.pChange < 0
                  //         ? "#dc2626"
                  //         : "#6b7280",

                  // }}
                  style={{
                    color:
                      indexPChange > 0
                        ? "#16a34a"
                        : indexPChange < 0
                          ? "#dc2626"
                          : "#6b7280",
                  }}
                >
                  {/* {dataForIndex?.lastPrice} (
                  {dataForIndex?.pChange > 0 ? "+" : ""}
                  {dataForIndex?.pChange}% ) */}
                  {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
                  {indexPChange}% )
                </span>
              </div>
            </div>
          </>
        )}

        {isIndia && <IndexTabs />}
      </div>

      <div
      // className="card"
      // style={{
      //   borderRadius: "12px",
      //   padding: "0 18px",
      //   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
      //   borderLeft: "4px solid #047cc2",
      // }}
      >
        {/* {dashboardLoading ? ( */}
        {isFirstLoad ? (
          <p
            style={{
              fontSize: "1rem",
              fontWeight: "700",
              // color: "white",
              display: "flex",
              gap: "1rem",
            }}
          >
            Fetching {isIndia ? selectedIndex : "Global"} data..{" "}
            <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
              <FaSpinner />
            </span>
          </p>
        ) : // dashboardMarketData &&
        //   Object.keys(dashboardMarketData).length > 0 ? (
        hasData ? (
          <>
            {isIndia && (
              <div className="section-toggle-wrapper">
                <div className=" section-toggle-tabs">
                  <button
                    className={activeSectionTab === "movers" ? "active" : ""}
                    onClick={() => setActiveSectionTab("movers")}
                  >
                    Market Movers
                  </button>
                  <button
                    className={
                      activeSectionTab === "smartmoney" ? "active" : ""
                    }
                    onClick={() => setActiveSectionTab("smartmoney")}
                  >
                    Smart Money
                  </button>
                </div>
              </div>
            )}
            {activeSectionTab === "movers" && (
              <>
                <div className="test-card-head">
                  <div className="card-head test-head-dash">
                    {/* <h2>Market Movers - {isIndia ? selectedIndex : "Global"}</h2> */}
                    <h2>
                      Market Movers{" "}
                      <InfoTooltip text={DASHTOOL?.marketMovers} />
                      {/* {isIndia ? (
                    <span>
                      {selectedIndex}{" "}
                      <span
                        style={{
                          color:
                            dataForIndex?.pChange > 0
                              ? "#16a34a"
                              : dataForIndex?.pChange < 0
                                ? "#dc2626"
                                : "#6b7280",
                          fontSize: "1.2rem",
                        }}
                      >
                        {dataForIndex?.lastPrice} (
                        {dataForIndex?.pChange > 0 ? "+" : ""}
                        {dataForIndex?.pChange}% )
                      </span>
                    </span>
                  ) : (
                    "Global"
                  )} */}
                    </h2>
                  </div>

                  <div className="test-card-stats">
                    <p style={{ color: "#16a34a" }}>
                      <IoMdTrendingUp />
                      Advances - {finalAdvances}
                      {/* <InfoTooltip text={DASHTOOL?.advances} /> */}
                    </p>
                    <p style={{ color: "#dc2626" }}>
                      <IoMdTrendingDown />
                      Declines - {finalDeclines}
                      {/* <InfoTooltip text={DASHTOOL?.declines} /> */}
                    </p>
                    <p style={{ color: "#6b7280" }}>
                      <FiMinusCircle />
                      Unchanged - {finalUnchanged}
                      {/* <InfoTooltip text={DASHTOOL?.unchanged} /> */}
                    </p>
                  </div>

                  <div
                    className="last-updated-head"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "13px",
                      color: "#6b7280",
                      // marginTop: "10px",
                      // marginBottom: "10px",
                    }}
                  >
                    {/* {lastUpdated && <span>As on {lastUpdated}</span>} */}
                    <span>As on {formattedQuoteTime}</span>

                    <FiRefreshCw
                      size={16}
                      onClick={handleRefresh}
                      style={{
                        cursor: "pointer",
                        transition: "0.2s",
                      }}
                      onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
                      onMouseOut={(e) => (e.target.style.color = "#6b7280")}
                    />
                  </div>
                </div>

                {Object.keys(dashboardMarketData || {}).length > 0 && (
                  <div>
                    {/* <div className="market-cards">
                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">
                        Top Gainers <InfoTooltip text={DASHTOOL?.topGainers} />
                      </h2>
                      <IoMdTrendingUp style={{ color: "#249966" }} />
                    </div>

                    {gainersToRender?.slice(0, 5)?.map((stock) => (
                      <div className="card-row" key={stock?.symbol}>
                        <div className="left">
                          <span style={{ display: "flex" }}>
                            <p
                              className="name"
                              onClick={() =>
                                isIndia
                                  ? // ? navigate(`/stockInfo/${stock?.symbol}`)
                                    // navigate(`/stockcard/${stock?.symbol}`)
                                    navigate(
                                      `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                    )
                                  : navigate(`/globalInfo/${stock?.symbol}`)
                              }
                            >
                              {stock?.symbol}
                            </p>
                            {isIndia && (
                              <span
                                className={`watchlist-icon ${
                                  isInWatchlist(stock?.symbol)
                                    ? "active"
                                    : "inactive"
                                }`}
                                onClick={() => handleAdd(stock?.symbol)}
                              >
                                {isInWatchlist(stock?.symbol) ? (
                                  <FaStar className="star" />
                                ) : (
                                  <FiStar className="star" />
                                )}
                              </span>
                            )}
                          </span>

                          <span className="price-watchlist">
                            <p className="price dash-price">
                              {isIndia
                                ? `₹${stock?.lastPrice}`
                                : ` ${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                            </p>
                          </span>
                        </div>

                        <div className="right">
                          <button
                            className="buy-btn"
                            onClick={() =>
                              isIndia
                                ? // navigate(`/stockInfo/${stock?.symbol}`)
                                  navigate(
                                    `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                  )
                                : navigate(`/globalInfo/${stock?.symbol}`)
                            }
                          >
                            {(() => {
                              const changePercent = isIndia
                                ? stock?.pChange
                                : stock?.regularMarketChangePercent;

                              if (changePercent == null) return "--";

                              return changePercent > 0
                                ? `+${changePercent.toFixed(2)}`
                                : `${changePercent.toFixed(2)}`;
                            })()}
                            %
                          </button>
                        </div>
                      </div>
                    ))}
                    {!isIndia && (
                      <div className="view-more-btn">
                        <button
                          className="rec-btn"
                          onClick={() => {
                            setMoreData(gainersToRender);
                            navigate("/globaltestdetail/gainers");
                          }}
                        >
                          View More
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">
                        Top Losers <InfoTooltip text={DASHTOOL?.topLosers} />
                      </h2>
                      <IoMdTrendingDown style={{ color: "#dc2626" }} />
                    </div>

                    {losersToRender?.slice(0, 5)?.map((stock) => (
                      <div className="card-row" key={stock?.symbol}>
                        <div className="left">
                          <span style={{ display: "flex" }}>
                            <p
                              className="name"
                              onClick={() =>
                                isIndia
                                  ? // navigate(`/stockInfo/${stock?.symbol}`)
                                    navigate(
                                      `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                    )
                                  : navigate(`/globalInfo/${stock?.symbol}`)
                              }
                            >
                              {stock?.symbol}
                            </p>
                            {isIndia && (
                              <span
                                className={`watchlist-icon ${
                                  isInWatchlist(stock?.symbol)
                                    ? "active"
                                    : "inactive"
                                }`}
                                onClick={() => handleAdd(stock?.symbol)}
                              >
                                {isInWatchlist(stock?.symbol) ? (
                                  <FaStar className="star" />
                                ) : (
                                  <FiStar className="star" />
                                )}
                              </span>
                            )}
                          </span>

                          <span className="price-watchlist">
                            <p className="price dash-price">
                              {isIndia
                                ? `₹${stock?.lastPrice}`
                                : ` ${stock?.regularMarketPrice}  ${stock?.financialCurrency}`}
                            </p>
                          </span>
                        </div>

                        <div className="right">
                          <button
                            className="sell-btn"
                            onClick={() =>
                              isIndia
                                ? // navigate(`/stockInfo/${stock?.symbol}`)
                                  navigate(
                                    `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                  )
                                : navigate(`/globalInfo/${stock?.symbol}`)
                            }
                          >
                            {isIndia
                              ? stock?.pChange?.toFixed(2)
                              : stock?.regularMarketChangePercent.toFixed(2)}
                            %
                          </button>
                        </div>
                      </div>
                    ))}
                    {!isIndia && (
                      <div className="view-more-btn">
                        <button
                          className="rec-btn"
                          onClick={() => {
                            setMoreData(losersToRender);
                            navigate("/globaltestdetail/losers");
                          }}
                        >
                          View More
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="market-card">
                    <div className="market-card-title">
                      <h2 className="card-title">
                        Most Active <InfoTooltip text={DASHTOOL?.mostActive} />
                      </h2>
                      <FaFireAlt style={{ color: "#3b82f6" }} />
                    </div>

                    {activesToRender?.slice(0, 5)?.map((stock) => (
                      <div className="card-row" key={stock?.symbol}>
                        <div className="left">
                          <span style={{ display: "flex", gap: "5px" }}>
                            <div className="active-price">
                              <p
                                className="name"
                                onClick={() =>
                                  isIndia
                                    ? // navigate(`/stockInfo/${stock?.symbol}`)
                                      navigate(
                                        `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                      )
                                    : navigate(`/globalInfo/${stock?.symbol}`)
                                }
                              >
                                {stock?.symbol}
                              </p>

                              <p className="price dash-price">
                                {isIndia
                                  ? `₹${stock?.lastPrice}`
                                  : ` ${stock?.regularMarketPrice} ${stock?.financialCurrency}`}
                              </p>
                            </div>

                            {isIndia && (
                              <span
                                className={`watchlist-icon ${
                                  isInWatchlist(stock?.symbol)
                                    ? "active"
                                    : "inactive"
                                }`}
                                onClick={() => handleAdd(stock?.symbol)}
                              >
                                {isInWatchlist(stock?.symbol) ? (
                                  <FaStar className="star" />
                                ) : (
                                  <FiStar className="star" />
                                )}
                              </span>
                            )}
                          </span>
                          <span className="price-watchlist">
                            <p className="volume">
                              Vol:{" "}
                              {isIndia
                                ? formatVolume(stock?.totalTradedVolume)
                                : formatVolume(stock?.regularMarketVolume)}
                            </p>
                          </span>
                        </div>

                        <div className="right">
                          <button
                            className={` ${(() => {
                              const changePercent = isIndia
                                ? stock?.pChange
                                : stock?.regularMarketChangePercent;

                              if (changePercent == null) return "";

                              return changePercent >= 0
                                ? "buy-btn"
                                : "sell-btn";
                            })()}`}
                            onClick={() =>
                              isIndia
                                ? // navigate(`/stockInfo/${stock?.symbol}`)
                                  navigate(
                                    `/stockdetail/${stock?.symbol}/${stock?.security_id}`,
                                  )
                                : navigate(`/globalInfo/${stock?.symbol}`)
                            }
                          >
                            {(() => {
                              const changePercent = isIndia
                                ? stock?.pChange
                                : stock?.regularMarketChangePercent;

                              if (changePercent == null) return "--";

                              return changePercent > 0
                                ? `+${changePercent.toFixed(2)}`
                                : `${changePercent.toFixed(2)}`;
                            })()}
                            %
                          </button>
                        </div>
                      </div>
                    ))}

                    {!isIndia && (
                      <div className="view-more-btn">
                        <button
                          className="rec-btn"
                          onClick={() => {
                            setMoreData(activesToRender);
                            navigate("/globaltestdetail/active");
                          }}
                        >
                          View More
                        </button>
                      </div>
                    )}
                  </div>
                </div> */}
                    {/* 
                {isIndia && (
                  <div className="view-more-btn">
                    <button
                      className="rec-btn"
                      onClick={() => {
                        setMoreData(stocks);

                        navigate(`/stocktestdetail/${selectedIndex}`);
                      }}
                    >
                      View More
                    </button>
                  </div>
                )} */}

                    <div className="market-image-grid">
                      <MarketCard
                        image={topGainersImg}
                        type="gainer"
                        title="Gainers"
                        data={gainersToRender}
                        isIndia={isIndia}
                        isInWatchlist={isInWatchlist}
                        handleAdd={handleAdd}
                        formatVolume={formatVolume}
                        selectedIndex={selectedIndex}
                      />

                      <MarketCard
                        image={topLosersImg}
                        type="loser"
                        title="Losers"
                        data={losersToRender}
                        isIndia={isIndia}
                        isInWatchlist={isInWatchlist}
                        handleAdd={handleAdd}
                        formatVolume={formatVolume}
                        selectedIndex={selectedIndex}
                      />

                      <MarketCard
                        image={mostActiveImg}
                        type="active"
                        title="Most Active"
                        data={activesToRender}
                        isIndia={isIndia}
                        isInWatchlist={isInWatchlist}
                        handleAdd={handleAdd}
                        formatVolume={formatVolume}
                        selectedIndex={selectedIndex}
                      />
                    </div>
                    <div className="mobile-market-section">
                      <div className="mobile-market-tabs">
                        <button
                          className={
                            activeMarketTab === "gainer" ? "active" : ""
                          }
                          onClick={() => setActiveMarketTab("gainer")}
                        >
                          Gainers
                        </button>

                        <button
                          className={
                            activeMarketTab === "loser" ? "active" : ""
                          }
                          onClick={() => setActiveMarketTab("loser")}
                        >
                          Losers
                        </button>

                        <button
                          className={
                            activeMarketTab === "active" ? "active" : ""
                          }
                          onClick={() => setActiveMarketTab("active")}
                        >
                          Most Active
                        </button>
                      </div>

                      {activeMarketTab === "gainer" && (
                        <MarketCard
                          image={topGainersImg}
                          type="gainer"
                          title="Gainers"
                          data={gainersToRender}
                          isIndia={isIndia}
                          isInWatchlist={isInWatchlist}
                          handleAdd={handleAdd}
                          formatVolume={formatVolume}
                          selectedIndex={selectedIndex}
                        />
                      )}

                      {activeMarketTab === "loser" && (
                        <MarketCard
                          image={topLosersImg}
                          type="loser"
                          title="Losers"
                          data={losersToRender}
                          isIndia={isIndia}
                          isInWatchlist={isInWatchlist}
                          handleAdd={handleAdd}
                          formatVolume={formatVolume}
                          selectedIndex={selectedIndex}
                        />
                      )}

                      {activeMarketTab === "active" && (
                        <MarketCard
                          image={mostActiveImg}
                          type="active"
                          title="Most Active"
                          data={activesToRender}
                          isIndia={isIndia}
                          isInWatchlist={isInWatchlist}
                          handleAdd={handleAdd}
                          formatVolume={formatVolume}
                          selectedIndex={selectedIndex}
                        />
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            {activeSectionTab === "smartmoney" && <SmartMoneyScreener />}
          </>
        ) : (
          <p>No Data Available</p>
        )}
      </div>
    </div>
  );
}
